import { errorHandler } from 'client/helpers/errorHandler';
import { IThunkAction } from 'types/IThunkAction';
import { startLoading, stopLoading } from 'client/_redux/actions/loading';
import * as categoryTourServices from 'dashboard/_redux/services/categoryTours';
import { ICategoryTour } from 'client/models/ICategoryTour';
import { CategoryToursDashboardTypes } from 'dashboard/_redux/types/categoryToursDashboardTypes';
import { toast } from 'react-toastify';
import { SearchQuery } from '../users';

export const getAllCategoryToursDashboard = (
  searchQuery: SearchQuery<ICategoryTour>,
): IThunkAction => async (dispatch) => {
  dispatch(startLoading());
  dispatch({ type: CategoryToursDashboardTypes.FETCH_CATEGORY_TOURS_START });
  try {
    const categoryTours = await categoryTourServices.getAllCategoryTours()(searchQuery);

    dispatch({
      type: CategoryToursDashboardTypes.FETCH_CATEGORY_TOURS_SUCCESS,
      payload: categoryTours,
    });
  } catch (error) {
    dispatch({ type: CategoryToursDashboardTypes.FETCH_CATEGORY_TOURS_FAILURE });
    errorHandler(error);
  }
  dispatch(stopLoading());
};

export const getCategoryTourDashboardById = (categoryTourId: string): IThunkAction => async (
  dispatch,
) => {
  dispatch(startLoading());
  dispatch({ type: CategoryToursDashboardTypes.UPDATE_CATEGORY_TOUR_START });
  try {
    const categoryTour = await categoryTourServices.getCategoryTourById()(categoryTourId);

    dispatch({
      type: CategoryToursDashboardTypes.UPDATE_CATEGORY_TOUR_SUCCESS,
      payload: categoryTour,
    });
  } catch (error) {
    dispatch({ type: CategoryToursDashboardTypes.UPDATE_CATEGORY_TOUR_FAILURE });
    errorHandler(error);
  }
  dispatch(stopLoading());
};

export const updateCategoryTourDashboard = (
  categoryTourId: string,
  values: Partial<ICategoryTour>,
): IThunkAction => async (dispatch) => {
  dispatch(startLoading());
  dispatch({ type: CategoryToursDashboardTypes.UPDATE_CATEGORY_TOUR_START });
  try {
    const categoryTour = await categoryTourServices.updateCategoryTour()(values, categoryTourId);

    toast('Catégorie de tour modifiée avec succès!', { type: 'success' });

    dispatch({
      type: CategoryToursDashboardTypes.UPDATE_CATEGORY_TOUR_SUCCESS,
      payload: categoryTour,
    });
  } catch (error) {
    dispatch({ type: CategoryToursDashboardTypes.UPDATE_CATEGORY_TOUR_FAILURE });
    errorHandler(error);
  }
  dispatch(stopLoading());
};

export const deleteCategoryTourDashboard = (
  categoryTourId: string,
  onSuccess?: () => void,
): IThunkAction => async (dispatch) => {
  dispatch(startLoading());

  try {
    await categoryTourServices.deleteCategoryTourById()(categoryTourId);
    toast('Catégorie de tour supprimée avec succès!', { type: 'success' });
    onSuccess?.();
  } catch (error) {
    errorHandler(error);
  }
  dispatch(stopLoading());
};

export const createCategoryTourDashboard = (values: {
  name: string;
  description: string;
}): IThunkAction => async (dispatch) => {
  dispatch(startLoading());

  try {
    await categoryTourServices.createCategoryTour()(values);
    toast('Catégorie de tour créée avec succès!', { type: 'success' });
  } catch (error) {
    errorHandler(error);
  }
  dispatch(stopLoading());
};
